// @flow

import { pendingActions } from 'common/pending-actions'
import { shareListeners } from 'common/share'
import { FsdvSlider } from 'common/slider-feedback'

import { SLIDER_CONFIG } from '../../data'

export default () => {
  new FsdvSlider('[data-slider]', SLIDER_CONFIG)
  pendingActions.addTag(1242)

  shareListeners(
    'Помогите ученикам раскрыть таланты! Зовите ребят на бесплатную олимпиаду Фоксфорда: они прокачают знания, а вы сможете выиграть ноутбук и вложиться в свою карьеру',
    'https://cdn.prod.website-files.com/64e255b02a0616d492d5b23d/66d6ebea999739fdb6155968_opengraph-olymp.jpg',
    'pathname'
  )
}
